/**
 * Values stored in cli_clients.device_name. They act as stable, user-visible token labels
 * (personal-access-token style) and are used for idempotent find-or-create per surface.
 */
export const CLI_CLIENT_LABEL_CONSOLE = 'console';

export const CLI_CLIENT_LABEL_DASHBOARD_ONBOARDING = 'dashboard onboarding';
